import React, { Component } from "react";
import { replaceCharacterWith } from "../../helper";

class AppliedFilters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCloseButtonClicked: false
    };
  }

  render() {
    const {
      filters = [],
      deleteFilter = () => {},
      isFromNodalSummary
    } = this.props;
    const { isCloseButtonClicked } = this.state;
    return filters.map((filter, key) => {
      return (
        <div key={key} className="mis-snackbar">
          {isFromNodalSummary ? filter.name : filter.displayName}
          {replaceCharacterWith(filter.label, "_", " ") || filter.label}
          <span
            className="close"
            onClick={() =>
              this.setState(
                {
                  isCloseButtonClicked: true
                },
                deleteFilter(filter, key)
              )
            }
          >
            X
          </span>
        </div>
      );
    });
  }
}

export default AppliedFilters;
